<div class="representante-pep-step">
  <p class="main-question">
    <strong>¿Desempeña o ha desempeñado funciones públicas?</strong>
  </p>
  <p class="subtext">
    Necesitamos saber si el representante legal es una Persona Expuesta
    Políticamente. Selecciona la opción que corresponda a su situación.
  </p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-wrapper">
    <!-- Consulta automática -->
    <div class="pep-check" *ngIf="pepCheckLoading">
      <div class="mini-spinner"></div>
      <span>Consultando listas PEP...</span>
    </div>

    <div class="pep-check detected" *ngIf="!pepCheckLoading && pepDetectado">
      <mat-icon>flag</mat-icon>
      <div>
        <span class="pep-check-title">Encontramos coincidencias en listas PEP</span>
        <span class="pep-check-desc" *ngIf="pepListasCoincidentes.length">
          {{ pepListasCoincidentes.join(', ') }}
        </span>
        <span class="pep-check-desc">
          Marcamos la declaración como PEP. Completa el detalle para continuar.
        </span>
      </div>
    </div>

    <!-- Opciones -->
    <div class="pep-options">
      <button
        type="button"
        class="pep-option"
        [class.selected]="form.get('es_pep')?.value === false"
        (click)="setPep(false)"
        [disabled]="loading"
      >
        <div class="option-icon no-pep-icon">
          <mat-icon>person_outline</mat-icon>
        </div>
        <div class="option-content">
          <span class="option-title">No tiene vínculos políticos</span>
          <span class="option-desc">
            Declara que ni él ni sus familiares cercanos ocupan o han ocupado cargos
            políticos relevantes.
          </span>
        </div>
        <div class="pep-checkmark" *ngIf="form.get('es_pep')?.value === false">
          <mat-icon>check_circle</mat-icon>
        </div>
      </button>

      <button
        type="button"
        class="pep-option"
        [class.selected]="form.get('es_pep')?.value === true"
        (click)="setPep(true)"
        [disabled]="loading"
      >
        <div class="option-icon is-pep-icon">
          <mat-icon>account_balance</mat-icon>
        </div>
        <div class="option-content">
          <span class="option-title">Tiene vínculos políticos</span>
          <span class="option-desc">
            El representante o un familiar cercano ocupa o ha ocupado cargos políticos
            de alta relevancia.
          </span>
        </div>
        <div class="pep-checkmark" *ngIf="form.get('es_pep')?.value === true">
          <mat-icon>check_circle</mat-icon>
        </div>
      </button>
    </div>

    <p class="field-error" *ngIf="isFieldInvalid('es_pep')">
      Selecciona una de las dos opciones.
    </p>

    <div class="info-box">
      <div class="info-header">
        <mat-icon>info</mat-icon>
        <span class="info-title">¿Qué es una Persona Expuesta Políticamente?</span>
      </div>
      <p class="info-text">
        Son personas que desempeñan o han desempeñado funciones públicas destacadas:
        Presidente, Senadores, Diputados, Ministros de Estado, Jueces de altas cortes,
        Comandantes de Fuerzas Armadas, Directores de empresas públicas, entre otros.
      </p>
      <p class="info-text info-note">
        Incluye a familiares cercanos y socios comerciales de estas personas.
      </p>
    </div>

    <!-- Detalle -->
    <div class="pep-declaration-fields" *ngIf="isPep">
      <div class="section-divider"><span>Datos PEP</span></div>

      <div class="form-grid">
        <div class="floating-group">
          <select id="pep_funcion" formControlName="pep_funcion">
            <option value="" disabled hidden></option>
            <option *ngFor="let funcion of pepFunciones" [value]="funcion">
              {{ funcion }}
            </option>
          </select>
          <label for="pep_funcion">¿Qué funciones desempeñó?</label>
        </div>
        <div class="floating-group">
          <input type="text" id="pep_institucion" formControlName="pep_institucion" />
          <label for="pep_institucion">¿En qué institución?</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="date" id="pep_inicio" formControlName="pep_fecha_inicio" />
          <label for="pep_inicio">Fecha de inicio</label>
        </div>
        <div class="floating-group">
          <input type="date" id="pep_termino" formControlName="pep_fecha_termino" />
          <label for="pep_termino">Fecha de término (opcional)</label>
        </div>
      </div>

      <p class="field-error" *ngIf="isFieldInvalid('pep_funcion') || isFieldInvalid('pep_institucion') || isFieldInvalid('pep_fecha_inicio')">
        Completa función, institución y fecha de inicio.
      </p>
    </div>

    <!-- Acciones -->
    <div class="actions">
      <button type="submit" class="continue-btn" [disabled]="loading">
        {{ loading ? 'Guardando...' : 'Continuar' }}
      </button>
      <button type="button" class="back-btn" (click)="goBack()" [disabled]="loading">
        Volver
      </button>
    </div>
  </form>
</div>
